export default __webpack_public_path__ + "static/media/logo.ddb88fc5.svg";